module.exports = __webpack_public_path__ + "img/MaterialSymbolsLightFullscreen.d0a99e40.svg";